import { quickBites } from "@/mocks/home";

export default function QuickBites() {
  return (
    <section id="bites" className="w-full bg-background-100 border-y border-background-200/80">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">
              QUICK BITES
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              吃瓜速览 · 短讯并行
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              一条不超过两行的短讯，密集铺开今天的讨论点，扫一眼就知道大家在聊什么。
            </p>
          </div>
          <span className="shrink-0 self-start md:self-auto inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-600">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-refresh-line"></i>
            </span>
            每小时滚动更新
          </span>
        </div>

        <ul className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-3">
          {quickBites.map((b, i) => (
            <li
              key={`${b.title}-${i}`}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 px-4 py-4 transition-colors hover:border-primary-300"
            >
              <span className="mt-0.5 w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className="ri-chat-smile-2-line text-base"></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-primary-100 px-2 py-0.5 text-xs font-medium text-primary-700">
                    {b.tag}
                  </span>
                  {b.hot && (
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600">
                      <i className="ri-fire-line"></i>
                      热议
                    </span>
                  )}
                  <span className="text-xs text-foreground-400">{b.time}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-900">
                  {b.title}
                </p>
                <p className="mt-1.5 text-xs text-foreground-500">来源 · {b.source}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}